// extracted by mini-css-extract-plugin
module.exports = {"vehiclesContainer":"vehicles-module--vehiclesContainer--3nVFz","vehiclesWrapper":"vehicles-module--vehiclesWrapper--Ay1wN","vehicle":"vehicles-module--vehicle--2kGnZ"};